<template>
  <div>
    <CRow>
      <CCol md="10">
        <CCard>
          
          <CCardHeader>
            <strong>CMS User</strong>
          </CCardHeader>
          <CCardBody>
            <CForm>
              <CInput
                label=" Name *"
                v-model="user.displayName"
                horizontal
                autocomplete="name"
                :disabled="mode.viewMode"
                type="name"
                :invalid-feedback="'Please Enter the Name'"
                :is-valid="
                  $v.user.displayName.$dirty
                    ? !$v.user.displayName.$error
                    : null
                "
                @blur="$v.user.displayName.$touch()"
              />

              <CInput
                label="Email *"
                v-model="user.email"
                horizontal
                :disabled="mode.viewMode"
                :invalid-feedback="'Please Enter the Email'"
                :is-valid="$v.user.email.$dirty ? !$v.user.email.$error : null"
                @blur="$v.user.email.$touch()"
              />

              <CInput
                label="Password *"
                v-model="user.password"
                horizontal
                :disabled="mode.viewMode"
                :invalid-feedback="'Please Enter the Password'"
                :is-valid="
                  $v.user.password.$dirty ? !$v.user.password.$error : null
                "
                @blur="$v.user.password.$touch()"
              />

              <!-- <div class="form-group row">
                  <div class="col-sm-12">   
 <label for="email">Email Address:</label>
      <input type="text" v-model="user.email" required> <br>
      <span v-if="msg.email">{{msg.email}}</span>
                  </div>
                  </div>           -->
              <!-- <div class="form-group row" v-if="mode.editMode||mode.newMode">
                        <div class="col-sm-12">
                     
               </div>
              </div> -->

              <!-- <CInput label="Mobile Number *"
               v-if="mode.viewMode"
               v-model="user.phoneNumber" 
               horizontal 
                 :disabled="mode.viewMode"
                  
                 :invalid-feedback="'Please Enter Mobile Number'"
                    :is-valid="$v.user.phoneNumber.$dirty? !$v.user.phoneNumber.$error : null "
                    @blur="$v.user.phoneNumber.$touch()"
                 
                 /> -->

              <CInput
                label="Mobile Number"
                v-model="user.phoneNumber"
                horizontal
                :disabled="mode.viewMode"
                type="number"
                :invalid-feedback="'Please Enter Mobile Number'"
                :is-valid="
                  $v.user.phoneNumber.$dirty
                    ? !$v.user.phoneNumber.$error
                    : null
                "
                @blur="$v.user.phoneNumber.$touch()"
              />

              <!-- <CSelect
                    label="Role *"
                    :value.sync="user.authority"
                    horizontal
                    :options="authority"
                   
                    :disabled="mode.viewMode"
                     
                  />  -->

              <!-- <CInput label="Gender"
               v-model="user.gender" horizontal 
                 :disabled="mode.viewMode"/>
                 

                  <CInput label="Country"
               v-model="user.country" horizontal 
                 :disabled="mode.viewMode"/> -->
            </CForm>
          </CCardBody>
          <CCardFooter align="right">
            <CButton
              v-if="mode.viewMode"
              class="mr-2"
              type="submit"
              color="primary"
              @click="editMode()"
            >
              Edit
            </CButton>

            <CButton
              v-if="!mode.viewMode"
              class="mr-2"
              type="submit"
              color="success"
              @click="saveCmsUser()"
            >
              Save
            </CButton>

            <CButton
              class="mr-2"
              type="Cancel"
              color="danger"
              @click="cancel()"
            >
              Cancel
            </CButton>
          </CCardFooter>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import Vue from "vue";
import {
  required,
  validateEmail,
  email,
  minLength,
  maxLength,
  url,
  requiredIf,
} from "vuelidate/lib/validators";
export default {
  name: "CMSUser",
  data() {
    return {
      mode: {
        newMode: false,
        editMode: false,
        viewMode: false,
      },
      uid: "",
      user: {
        // uid:'',
        displayName: "",
        email: "",
        password: "",
        phoneNumber: "",
        //authority: "ROLE_ADMIN",
        //authority: "ROLE_ADMIN"
      },
      msg: [],
      categories: [],
      selected: [],
      show: true,
      // authoritys: [ "ROLE_ADMIN", "ROLE_SUPER ADMIN"],
    };
  },

  validations: {
    user: {
      displayName: {
        required,
      },
      email: {
        required,
        email,
      },
      password: {
        required,
      },

      phoneNumber: {
       
      },
    },
  },
  created() {
    if (this.$route.params.mode == "new") {
      this.mode.newMode = true;
      this.mode.viewMode = false;
      this.mode.editMode = false;
    }
    if (this.$route.params.mode == "view") {
      this.mode.viewMode = true;
      this.uid = this.$route.params.uid;
      this.getCmsUser();
    }
    if (this.$route.params.mode == "edit") {
      this.mode.editMode = true;
      this.uid = this.$route.params.uid;
      this.getCmsUser();
    }
  },
  //       watch: {
  //   email(value){
  //     // binding this to the data value in the email input
  //     this.user.email = value;
  //     this.validateEmail(value);
  //   }
  // },

  methods: {
    //    validateEmail(value){
    //     if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(value))
    // {
    //   this.msg['email'] = '';
    // } else{
    //   this.msg['email'] = 'Invalid Email Address';
    // }
    //   },

    editMode() {
      this.mode.editMode = true;
      this.mode.viewMode = false;
    },
    cancel() {
      this.$router.push({ name: "CMSUsers" });
    },

    getCmsUser() {
      this.apiGetSecure(
        process.env.VUE_APP_API_HOST + "/web/secure/get/cmsUser/" + this.uid
      )
        .then((response) => response.json())
        .then((data) => (this.user = data));
    },

    saveCmsUser() {
      this.$v.user.$touch();
      if (this.$v.user.$invalid) {
        console.log("form is invalid", JSON.stringify(this.$v.user));
      } else {
        this.apiPostSecure(
          process.env.VUE_APP_API_HOST + "/web/secure/save/cmsuser",
          this.user
        ).then((user) => {
          console.log(JSON.stringify(user));
          this.$router.push({ name: "CMSUsers" });
        });
      }
    },
  },
  mounted() {
    //this.getCmsUser()
  },
};
</script>
